var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.material),function(color,index){return _c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],key:'m' + color,staticClass:"color-btn",class:[color, { 'not-selected': color !== _vm.selectedColor }],on:{"click":function($event){return _vm.onSelect(color)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f740e716","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorPicker.vue
// module id = 666
// module chunks = 1